import ace from 'ace-builds'

//输入类型
import keybindingEmacs from "ace-builds/src-noconflict/keybinding-emacs.js?url";
ace.config.setModuleUrl('ace/keyboard/emacs', keybindingEmacs);

import keybindingSublime from "ace-builds/src-noconflict/keybinding-sublime.js?url";
ace.config.setModuleUrl('ace/keyboard/sublime', keybindingSublime);

import keybindingVim from "ace-builds/src-noconflict/keybinding-vim.js?url"
ace.config.setModuleUrl('ace/keyboard/vim', keybindingVim);

import keybindingVscode from "ace-builds/src-noconflict/keybinding-vscode.js?url"
ace.config.setModuleUrl('ace/keyboard/vscode', keybindingVscode);

// 导入默认语法模式
import css from "ace-builds/src-noconflict/mode-css.js?url"
ace.config.setModuleUrl('ace/mode/css', css);

import html from "ace-builds/src-noconflict/mode-html.js?url"
ace.config.setModuleUrl('ace/mode/html', html);

import java from "ace-builds/src-noconflict/mode-java.js?url"
ace.config.setModuleUrl('ace/mode/java', java);

import javascript from "ace-builds/src-noconflict/mode-javascript.js?url"
ace.config.setModuleUrl('ace/mode/javascript', javascript);

import json from "ace-builds/src-noconflict/mode-json.js?url"
ace.config.setModuleUrl('ace/mode/json', json);

import markdown from "ace-builds/src-noconflict/mode-markdown.js?url"
ace.config.setModuleUrl('ace/mode/markdown', markdown);

import scss from "ace-builds/src-noconflict/mode-scss.js?url"
ace.config.setModuleUrl('ace/mode/scss', scss);

import sql from "ace-builds/src-noconflict/mode-sql.js?url"
ace.config.setModuleUrl('ace/mode/sql', sql);

import text from "ace-builds/src-noconflict/mode-text.js?url"
ace.config.setModuleUrl('ace/mode/text', text);

// 导入默认主题
import chrome from "ace-builds/src-noconflict/theme-chrome.js?url"
import eclipse from "ace-builds/src-noconflict/theme-eclipse.js?url"
import monokai from "ace-builds/src-noconflict/theme-monokai.js?url"
import textmate from "ace-builds/src-noconflict/theme-textmate.js?url"
import github from "ace-builds/src-noconflict/theme-github.js?url"
ace.config.setModuleUrl('ace/theme/chrome', chrome);
ace.config.setModuleUrl('ace/theme/eclipse', eclipse);
ace.config.setModuleUrl('ace/theme/github', github);
ace.config.setModuleUrl('ace/theme/monokai', monokai);
ace.config.setModuleUrl('ace/theme/textmate', textmate);

// 导入语言的自动提示
// import css from
import sni_css from "ace-builds/src-noconflict/snippets/css.js?url"
import sni_html from "ace-builds/src-noconflict/snippets/html.js?url"
import sni_java from "ace-builds/src-noconflict/snippets/java.js?url"
import sni_javascript from "ace-builds/src-noconflict/snippets/javascript.js?url"
import sni_json from "ace-builds/src-noconflict/snippets/json.js?url"
import sni_markdown from "ace-builds/src-noconflict/snippets/markdown.js?url"
import sni_scss from "ace-builds/src-noconflict/snippets/scss.js?url"
import sni_sql from "ace-builds/src-noconflict/snippets/sql.js?url"
import sni_text from "ace-builds/src-noconflict/snippets/text.js?url"
ace.config.setModuleUrl('ace/snippets/css', sni_css);
ace.config.setModuleUrl('ace/snippets/html', sni_html);
ace.config.setModuleUrl('ace/snippets/java', sni_java);
ace.config.setModuleUrl('ace/snippets/javascript', sni_javascript);
ace.config.setModuleUrl('ace/snippets/json', sni_json);
ace.config.setModuleUrl('ace/snippets/markdown', sni_markdown);
ace.config.setModuleUrl('ace/snippets/scss', sni_scss);
ace.config.setModuleUrl('ace/snippets/sql', sni_sql);
ace.config.setModuleUrl('ace/snippets/text', sni_text);


// 语法校验
import css_worker from "ace-builds/src-noconflict/worker-css.js?url"
import html_worker from "ace-builds/src-noconflict/worker-html.js?url"
import javascript_worker from "ace-builds/src-noconflict/worker-javascript.js?url"
import json_worker from "ace-builds/src-noconflict/worker-json.js?url"
import lua_worker from "ace-builds/src-noconflict/worker-lua.js?url"
ace.config.setModuleUrl('ace/mode/css_worker', css_worker);
ace.config.setModuleUrl('ace/mode/html_worker', html_worker);
ace.config.setModuleUrl('ace/mode/javascript_worker', javascript_worker);
ace.config.setModuleUrl('ace/mode/json_worker', json_worker);
ace.config.setModuleUrl('ace/mode/lua_worker', lua_worker);


import "ace-builds/src-noconflict/ext-language_tools"
import "ace-builds/src-noconflict/ext-searchbox"

// #region lua语法高亮
import 'ace-builds/src-noconflict/mode-lua'
import 'ace-builds/src-noconflict/snippets/lua'
// #endregion

ace.require("ace/ext/language_tools");
